import { createContext } from 'react';
import type { UserAddress } from '../types/user-address';

export interface AddressesContextProps {
  // Listagem de endereços salvos pelo usuário
  addresses: UserAddress[];

  // Endereço
  address: {
    geolocation: UserAddress | null; // Endereço por geolocalização
    selected: UserAddress | null; // Endereço selecionado no state
  };

  // Estados do React Query
  isLoading: boolean;
  // Métodos
  handleChangeSelectedAddress: (address: UserAddress) => Promise<void>;
}

export const AddressesContext = createContext<AddressesContextProps>({} as AddressesContextProps);
